import styled from "styled-components";
import { Loader2 } from "./Icons";

export const Loading = styled(Loader2).attrs({
  size: 24,
  className: "icon-spin",
})``;
